import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IV2CreateConsultingResponse } from '../../repositories/newbuilding-flat-view-order/entities/consulting_request/V2CreateConsultingResponse';
import { ICpa } from '../../types/cpa/cpa';

const initialState: ICpa = {
  hhQueryParams: { siteId: '', clickId: '' },
  isCPALanding: false,
  hhConversionId: '',
  cityAds: null,
};

export const cpaSlice = createSlice({
  name: 'cpa',
  initialState,
  reducers: {
    setHhConversionId: (state, action: PayloadAction<IV2CreateConsultingResponse>) => {
      return {
        ...state,
        hhConversionId: action.payload.hhConversionId,
      };
    },
  },
});

export const {
  reducer: cpaReducer,
  actions: { setHhConversionId },
} = cpaSlice;
